import React from 'react'
import { ServiceItem } from '../../types/packageFlowModel';

interface ApplicationProcessProps {
    serviceList: ServiceItem[];
  }

const ApplicationProcess: React.FC<ApplicationProcessProps> = ({serviceList}) => {
  const indexx = serviceList.findIndex(
    step => step.service_id === step.step_service_id
  );
      return (
        <div>
          {/* Steps */}
          {serviceList?.map((step, index ) => {
            let stepClass = "";
            let stepIcon: JSX.Element;
            let stepTextColor = "";
            let stepBackground = "";

           
  
            if (step.service_id === step.step_service_id) {
              stepClass = "current-step";
              stepIcon = (
                <img src="https://goodhand.b-cdn.net/Assets/Flow/blueTick.svg" />
              );
              stepTextColor = "text-primary";
              stepBackground = "bg-3";
            } else if (indexx > index) {
              stepClass = "before-current-step";
              stepIcon = (
                <img src="https://goodhand.b-cdn.net/Assets/Flow/greenTick.svg" />
              );
              stepTextColor = "text-green";
              stepBackground = "bg-light-green";
            } else {
              stepClass = "after-current-step";
              stepIcon = (
                <img src="https://goodhand.b-cdn.net/Assets/Flow/redCross.svg" />
              );
              stepTextColor = "text-danger";
              stepBackground = "bg-light-red"; // Red for steps after current step
            }
  
            return (
              <div
                key={index}
                className={`d-flex py-3 ${
                  index !== serviceList.length - 1
                    ? "border-bottom border-dark border-opacity-10"
                    : ""
                }`}
                
              >
                <div className={`all-serv-step bg-white ${stepClass}`}>
                  {stepIcon}
                </div>
                <div style={{ flex: 1 }}>
                  <div
                    className={`d-flex align-items-center gap-2 ind-steps ${stepBackground} px-3 w-auto p-1`}
                  >
                    <p className={`font-12 mb-0 ${stepTextColor}`}>
                      <span className="ff-semibold">
                        {step.service_id === step.step_service_id ? "Current Step" : `Step ${index + 1}`}
                      </span>
                    </p>
                  </div>
                  <p className="font-13 ff-semibold mb-0 text-main">
                    {step.title}
                  </p>
                  <p className="font-12 mb-0 text-black-50 ff-medium">
                    {step.description}
                  </p>
  
                  {step.service_id === step.step_service_id && (
                    <div className="rounded-0 bg-beige text-noti font-10 p-2 mb-0 px-3 my-2 ff-medium d-flex align-items-center justify-content-between gap-2">
                      <div className="d-flex align-items-center gap-1">
                        <svg
                          width="10"
                          height="9"
                          viewBox="0 0 10 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.99995 0C5.43407 0 5.83864 0.212286 6.08638 0.566853L6.13411 0.639585L9.82252 6.79815C9.93461 6.99228 9.9956 7.21169 9.99977 7.43583C10.0039 7.65997 9.95116 7.88149 9.84637 8.07967C9.74159 8.27785 9.58822 8.44619 9.40063 8.56893C9.21304 8.69166 8.99737 8.76479 8.77382 8.78145L8.68518 8.78509H1.30972C1.08594 8.78257 0.866439 8.72339 0.671715 8.61308C0.476991 8.50277 0.31339 8.34492 0.196184 8.15427C0.0789777 7.96361 0.0119871 7.74637 0.00146504 7.52282C-0.00905701 7.29927 0.0372326 7.0767 0.136013 6.87588L0.181016 6.79178L3.86761 0.637766C3.98564 0.443124 4.15185 0.282185 4.35019 0.170474C4.54853 0.0587625 4.77231 5.00791e-05 4.99995 0ZM4.99995 4.24117H4.54537L4.49219 4.24435C4.38171 4.25749 4.27988 4.3107 4.206 4.39389C4.13211 4.47708 4.09131 4.58448 4.09131 4.69574C4.09131 4.80701 4.13211 4.9144 4.206 4.9976C4.27988 5.08079 4.38171 5.13399 4.49219 5.14713L4.54537 5.15032V6.51404L4.54856 6.56722C4.56052 6.66869 4.60632 6.76317 4.67857 6.83542C4.75082 6.90766 4.8453 6.95346 4.94676 6.96543L4.99995 6.96861H5.45452L5.50771 6.96543C5.60918 6.95346 5.70365 6.90766 5.7759 6.83542C5.84815 6.76317 5.89395 6.66869 5.90591 6.56722L5.9091 6.51404L5.90591 6.46085C5.89505 6.36811 5.85588 6.28096 5.79374 6.21126C5.73161 6.14156 5.64951 6.09268 5.55862 6.07128L5.50771 6.06219L5.45452 6.05946V4.69574L5.45134 4.64256C5.43937 4.54109 5.39357 4.44661 5.32133 4.37437C5.24908 4.30212 5.1546 4.25632 5.05313 4.24435L4.99995 4.24117ZM5.00449 2.87745L4.94676 2.88063C4.83628 2.89377 4.73445 2.94698 4.66057 3.03017C4.58669 3.11336 4.54588 3.22076 4.54588 3.33202C4.54588 3.44329 4.58669 3.55068 4.66057 3.63388C4.73445 3.71707 4.83628 3.77027 4.94676 3.78341L4.99995 3.7866L5.05768 3.78341C5.16816 3.77027 5.26999 3.71707 5.34387 3.63388C5.41776 3.55068 5.45856 3.44329 5.45856 3.33202C5.45856 3.22076 5.41776 3.11336 5.34387 3.03017C5.26999 2.94698 5.16816 2.89377 5.05768 2.88063L5.00449 2.87745Z"
                            fill="#CF770C"
                          />
                        </svg>
  
                        <span className="ff-semibold">
                          Choosing individual? You’ll miss out big discounts &
                          hassle-free service in our packages!
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      );
}

export default ApplicationProcess

